import React, { useState } from "react";
import "./App.css";
import DAOStatus from "./components/DAOStatus";
import ConnectWallet from "./components/ConnectWallet";
import ProposalList from "./components/ProposalList";
import CatContest from "./components/CatContest";
import catLogo from "./assets/ICON.png";

// ✅ Header
function Header() {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#ffcc33", padding: "1rem" }}>
      <img src={catLogo} alt="CatCoin Logo" style={{ width: "64px", height: "64px", borderRadius: "50%" }} />
      <h1 style={{ marginLeft: "12px" }}>CatCoin DAO — Dashboard</h1>
    </div>
  );
}

function App() {
  const [activeTab, setActiveTab] = useState("status"); // ✅ default to Status

  return (
    <div className="App">
      <Header /> {/* header */}

      <main style={mainStyle}>
        {/* Wallet Connection */}
        <section style={sectionStyle}>
          <h2>🔌 Connect Your Wallet</h2>
          <ConnectWallet />
        </section>

        {/* Tabs Navigation */}
        <div style={tabNav}>
          <button
            style={activeTab === "status" ? tabBtnActive : tabBtn}
            onClick={() => setActiveTab("status")}
          >
            🏛️ DAO Status
          </button>

          <button
            style={activeTab === "proposals" ? tabBtnActive : tabBtn}
            onClick={() => setActiveTab("proposals")}
          >
            📜 Proposals
          </button>

          <button
            style={activeTab === "contest" ? tabBtnActive : tabBtn}
            onClick={() => setActiveTab("contest")}
          >
            🐾 Cat Contest
          </button>
        </div>

        {/* ✅ Status Tab */}
        {activeTab === "status" && (
          <section style={sectionStyle}>
            <h2>🏛️ DAO Status Overview</h2>
            <DAOStatus />
          </section>
        )}

        {/* 📜 Proposals Tab */}
        {activeTab === "proposals" && (
          <section style={sectionStyle}>
            <ProposalList />
          </section>
        )}

        {/* 🐾 Cat Contest Tab */}
        {activeTab === "contest" && (
          <section style={sectionStyle}>
            <CatContest />
          </section>
        )}
      </main>

      <footer style={footerStyle}>
        <p>© 2025 CatCoin DAO | Sepolia Testnet</p>
      </footer>
    </div>
  );
}

// 🌈 Styles
const headerStyle = {
  backgroundColor: "#ffcc33",
  padding: "1.5rem",
  color: "#000",
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
};

const mainStyle = {
  padding: "2rem",
  maxWidth: "1000px",
  margin: "0 auto",
  textAlign: "left",
};

const sectionStyle = {
  background: "#fff",
  borderRadius: "12px",
  padding: "1.5rem",
  marginBottom: "1.5rem",
  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
};

const tabNav = {
  display: "flex",
  justifyContent: "center",
  marginBottom: "1rem",
  gap: "10px",
};

const tabBtn = {
  padding: "0.7rem 1.5rem",
  borderRadius: "10px",
  border: "1px solid #ccc",
  cursor: "pointer",
  backgroundColor: "#f5f5f5",
  fontWeight: "bold",
  color: "#555",
  transition: "0.2s",
};

const tabBtnActive = {
  ...tabBtn,
  backgroundColor: "#ffcc33",
  borderColor: "#ffb700",
  color: "#000",
};

const footerStyle = {
  textAlign: "center",
  padding: "1rem",
  fontSize: "0.9rem",
  color: "#666",
};

export default App;